<div class="container">
  <div class="container__section">
    <app-book-item
      caption="毎日読める絵本"
      photo="/assets/images/everyday-book.png"
      [summary]="[
        '毎日の絵本タイムに。',
        '子どもの心を育む絵本。'
      ]"
      (buttonClick)="onAdventureBooksButtonClick()"
    ></app-book-item>
  </div>
  <div class="container__section">
    <app-book-item
      caption="お誕生日の絵本"
      photo="/assets/images/birthday-books.png"
      [summary]="[
        'お誕生日は特別な日。',
        '心からのおめでとう！を、絵本で。'
      ]"
      (buttonClick)="onBirthdayBooksButtonClick()"
    ></app-book-item>
  </div>
  <div class="container__section">
    <app-book-item
      caption="生まれてきた子に"
      [photo]="WelcomeToTheWorld.previewPhoto"
      [summary]="WelcomeToTheWorld.summary"
      (buttonClick)="onButtonClick(WelcomeToTheWorld.alias)"
    ></app-book-item>
  </div>
</div>
